import { create } from 'zustand';

export type QrKey = 'site-qr' | 'visit-qr';

interface QrMeta {
	isVerified: boolean;
	lastVerifiedAt?: number;
}

interface QrVerificationState {
	byKey: Record<QrKey, QrMeta | undefined>;
	isVerified: (key: QrKey) => boolean;
	setVerified: (key: QrKey, v: boolean) => void;
	resetFor: (key: QrKey) => void;
	resetAll: () => void;
}

export const useQrVerificationStore = create<QrVerificationState>((set, get) => ({
	byKey: {} as Record<QrKey, QrMeta | undefined>,
	isVerified: (key: QrKey): boolean => Boolean(get().byKey[key]?.isVerified),

	setVerified: (key: QrKey, v: boolean): void =>
		set((s) => ({
			byKey: {
				...s.byKey,
				[key]: { isVerified: v, lastVerifiedAt: v ? Date.now() : undefined },
			},
		})),
	resetFor: (key: QrKey): void =>
		set((s) => {
			const copy = { ...s.byKey };
			delete copy[key];
			return { byKey: copy };
		}),
	resetAll: (): void => set({ byKey: {} as Record<QrKey, QrMeta | undefined> }),
}));
